/**
 * Helpers for "select all filtered records" in paginated list views.
 */

export function normalizeItemId(id) {
  if (id == null) return "";
  return String(id);
}

/** Backend may return `{ items }` or a bare array when `all=true`. */
export function normalizeListResponseItems(data) {
  if (Array.isArray(data)) return data;
  return data?.items || [];
}

export function extractItemIds(items) {
  return (items || [])
    .map((item) => normalizeItemId(item && item._id))
    .filter((id) => id !== "");
}

export function isItemIdSelected(selectedIds, itemId) {
  const normalized = normalizeItemId(itemId);
  if (!normalized || !Array.isArray(selectedIds)) return false;
  return selectedIds.some((id) => normalizeItemId(id) === normalized);
}

export function isAllFilteredSelected(selectedIds, total) {
  const totalCount = Number(total) || 0;
  if (!totalCount || !Array.isArray(selectedIds)) return false;
  return selectedIds.length === totalCount;
}

export function isHeaderCheckboxIndeterminate(selectedIds, total) {
  const totalCount = Number(total) || 0;
  const selectedCount = Array.isArray(selectedIds) ? selectedIds.length : 0;
  return selectedCount > 0 && selectedCount < totalCount;
}
